/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/user': {
    width: 26,
    height: 32,
    viewBox: '0 0 26 32',
    data: '<path pid="0" _fill="#B2B2B2" d="M16 19h-6C4.486 19 0 23.486 0 29v.65l.594.264C.786 29.999 5.375 32 13 32c7.625 0 12.214-2.001 12.406-2.086L26 29.65V29c0-5.514-4.486-10-10-10zm-3-2c4.579 0 8-4.751 8-9 0-4.411-3.589-8-8-8S5 3.589 5 8c0 4.249 3.421 9 8 9z"/>'
  }
})
